import BaseModal from 'components/atoms/base-modal';
import BaseSelect from 'components/molecules/select/base';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import DiffSection from './diff-section';

import type { RunbookLog } from 'infrastructure/classes/runbook-log';

type Props = {
  comparerOpened: boolean;
  setComparerOpened: (value: boolean) => void;
  currentData?: RunbookLog;
  history: RunbookLog[];
};

const RunBookCompareContent: React.FC<Props> = ({
  comparerOpened,
  setComparerOpened,
  currentData,
  history,
}) => {
  const [selectIndex, setSelectIndex] = useState(0);
  const { t } = useTranslation();
  const oldData = history[selectIndex];

  return (
    <BaseModal
      title={t('runbook.clinicalInstructionsComparison')}
      open={comparerOpened}
      onCancel={() => setComparerOpened(false)}
      allowScrolling={false}
      width={1000}
      padding={0}
    >
      <div>
        <div className={s['runbook-select-wrapper']}>
          <div className={s['runbook-select']}>
            <div>{t('runbook.currentVersion')}</div>
            <BaseSelect
              options={[]}
              disabled
              suffixIcon={<div />}
              width="338px"
              value={{
                label: currentData?.createdAt ?? '',
                value: currentData?.createdAt ?? '',
              }}
            />
          </div>
          <div className={s['runbook-select']}>
            <div>{t('runbook.comparisonVersion')}</div>
            <BaseSelect
              defaultValue={{
                label: oldData?.createdAt ?? '',
                value: selectIndex,
              }}
              options={history.map((el, idx) => ({
                label: el.createdAt,
                value: idx,
              }))}
              width="338px"
              onSelect={(v) => {
                setSelectIndex(v.value);
              }}
            />
          </div>
        </div>
        <div className={s['runbook-select-body-wrapper']}>
          <DiffSection oldData={oldData} currentData={currentData} current />
          <DiffSection
            oldData={oldData}
            currentData={currentData}
            current={false}
          />
        </div>
      </div>
    </BaseModal>
  );
};

export default RunBookCompareContent;
